import HttpService from "@core/services/http/http.service";
import {
  ChangeInfoResponse,
  GetDetailResponse,
  LoginResponse,
  VerifyMfaSendMethodResponse,
  SignUpRequest,
  User,
  UpdateAdmin,
  UserInfo,
  VerifyMfaCode,
  VerifyEmailSendMethodResponse,
  VerifyEmailCodeResponse,
  ChangePasswordRequest,
} from "@app/types";
import { RequestContentType, Signal } from "@core/services/http/http.type";

class _AuthService {
  public login(email: string, password: string) {
    return HttpService.post<LoginResponse>("/admin/api/v2/auth/login", {
      body: {
        email,
        password,
      },
    });
  }

  public signUp(signUpRequest: SignUpRequest) {
    return HttpService.post<LoginResponse>("/user/api/v2/auth/register", {
      body: { ...signUpRequest },
    });
  }

  public sendSmsCode(
    body: { type: string },
    headers?: Record<string, unknown>
  ) {
    return HttpService.post<GetDetailResponse<VerifyEmailSendMethodResponse>>(
      "/admin/api/v2/auth/sms",
      {
        body,
        headers,
      }
    );
  }

  public sendEmailCode(headers?: Record<string, unknown>) {
    return HttpService.post<GetDetailResponse<VerifyEmailSendMethodResponse>>(
      "/admin/api/v2/auth/email",
      {
        body: {},
        headers,
      }
    );
  }

  public sendMfaCode(headers?: Record<string, unknown>) {
    return HttpService.post<GetDetailResponse<VerifyMfaSendMethodResponse>>(
      "/admin/api/v2/auth/mfa-register",
      {
        headers,
      }
    );
  }

  public verifySmsCode(
    body: { code: string },
    headers?: Record<string, unknown>
  ) {
    return HttpService.post<GetDetailResponse<VerifyEmailCodeResponse>>(
      "/admin/api/v2/auth/sms-verify-code",
      {
        body,
        headers,
      }
    );
  }

  public verifyEmailCode(
    body: { code: string },
    headers?: Record<string, unknown>
  ) {
    return HttpService.post<GetDetailResponse<VerifyEmailCodeResponse>>(
      "/admin/api/v2/auth/email-verify-code",
      {
        body,
        headers,
      }
    );
  }

  public verifyMfaCode(
    code: string,
    isVerifyRegister = true,
    headers?: Record<string, unknown>
  ) {
    return HttpService.post<GetDetailResponse<VerifyMfaCode>>(
      "/admin/api/v2/auth/mfa-verify-code",
      {
        body: { code, isVerifyRegister: isVerifyRegister ? true : undefined },
        headers,
      }
    );
  }

  public getUserInfo(signal?: Signal) {
    return HttpService.get<GetDetailResponse<UserInfo>>(
      "/admin/api/v2/auth/info",
      { signal }
    );
  }

  public getUserById(userId: number) {
    return HttpService.get<GetDetailResponse<User>>(
      `/admin/api/v2/users/${userId}`
    );
  }

  public updateThumbnail(thumbnail: File) {
    return HttpService.patch("/admin/api/v2/auth/info/thumbnail", {
      body: { thumbnail },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public changeInfo(updateAdmin: UpdateAdmin) {
    return HttpService.patch<ChangeInfoResponse>("/admin/api/v2/auth/info", {
      body: { ...updateAdmin },
    });
  }

  public changePassword(bodyPassword: ChangePasswordRequest) {
    return HttpService.post("/admin/api/v2/auth/change-password", {
      body: {
        oldPassword: bodyPassword.oldPassword,
        newPassword: bodyPassword.newPassword,
      },
    });
  }
}

const AuthService = new _AuthService();

export default AuthService;
